import React from 'react'
import { Link } from 'react-router-dom'
import { employmentTypeLabel, locationTypeLabel } from '../utils/employmeLabels'

const AiJobMatchCard = ({ item, compact = false }) => {
  const job = item?.job
  if (!job?._id) return null

  const score =
    typeof item.fitScore === 'number'
      ? Math.round(Math.max(0, Math.min(100, item.fitScore)))
      : null

  const locationLabel = [job.location?.city, job.location?.state].filter(Boolean).join(', ')
  const metaParts = [locationLabel, locationTypeLabel(job.locationType)].filter(Boolean)

  return (
    <Link
      to={`/jobs/${job._id}`}
      className={`group block rounded-lg border border-slate-200 bg-white transition-colors duration-200 hover:border-sky-200 hover:bg-sky-50/40 ${
        compact ? 'px-3.5 py-3' : 'p-4'
      }`}
    >
      <div className="flex items-start justify-between gap-2">
        <div className="min-w-0 flex-1">
          <div
            className={`font-semibold text-slate-900 transition-colors group-hover:text-[#008FCC] ${
              compact ? 'text-xs' : 'text-sm'
            }`}
          >
            {job.title || 'Job'}
          </div>
          {metaParts.length > 0 && (
            <div className={`mt-0.5 text-slate-500 ${compact ? 'text-[11px]' : 'text-xs'}`}>
              {metaParts.join(' · ')}
            </div>
          )}
        </div>
        {score != null && (
          <span
            className={`shrink-0 whitespace-nowrap rounded-md bg-sky-50 font-semibold text-sky-800 ${
              compact ? 'px-2 py-0.5 text-[10px]' : 'px-2.5 py-0.5 text-xs'
            }`}
          >
            {score}% match
          </span>
        )}
      </div>

      {job.description && (
        <p
          className={`mt-2 leading-relaxed text-slate-600 line-clamp-2 ${
            compact ? 'text-[11px]' : 'text-sm'
          }`}
        >
          {job.description}
        </p>
      )}

      {item.reason && (
        <p
          className={`mt-1.5 leading-relaxed text-slate-600 line-clamp-2 ${
            compact ? 'text-[11px]' : 'text-xs'
          }`}
        >
          {item.reason}
        </p>
      )}

      <span
        className={`mt-2 inline-flex items-center gap-1 font-medium text-[#00A5E6] group-hover:text-[#008FCC] ${
          compact ? 'text-[11px]' : 'text-xs'
        }`}
      >
        View full job description
        <svg className="h-3 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
        </svg>
      </span>
    </Link>
  )
}

export default AiJobMatchCard
